import { css } from 'lit';

export const style = css`
  .primary-active-income-prefilled {
    margin-bottom: -0.5rem;
    margin-top: -1rem;
  }

  .co-active-income-prefilled {
    margin-bottom: -0.5rem;
  }

  .co-radio-group {
    margin-bottom: 1.25rem;
  }
`;
